export enum ClaimFileType {
  Others = 'others',
  Quote = 'quote',
}

export type ClaimFile = {
  fileName: string
  fileSize: number
  contentType: string
}

export type PresignedClaimFileUrl = {
  fileName: string
  signedURL: string
}

export type PresignedClaimFileUrlResponse = {
  files: PresignedClaimFileUrl[]
}
